export class CodellaboratePayload {
    constructor(payload) {
        this.payload = payload;
    }
    getFileName() {
        return this.payload.content;
    }
    getContent() {
        try {
            return atob(this.payload.content);
        }
        catch (e) {
            return '';
        }
    }
}
